import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, Text } from "../../config";
import Modal from "../Modal";

const successImg = require("../../assets/images/RequestSuccessImg.png");

const RequestSuccessModal = ({ setClose,id }) => {
  const navigate = useNavigate();
  const GoToBookingStatus = () => {
    navigate("/user/bookings");
  };
  return (
    <Modal setClose={GoToBookingStatus}>
      <RequestSuccessContainer>
        <SuccessImg src={successImg} alt="success" />
        <HeaderSubheader>
          <SuccessHeader>{Text.success}</SuccessHeader>
          <SuccessSubheader>
            {Text.yourRequestSubmittedSuccessfully}
            <br /> {Text.pleaseCheckStatusOfRequest} for Request ID: {id}
          </SuccessSubheader>
        </HeaderSubheader>
        <SuccessContinue onClick={GoToBookingStatus}>
          {Text.takeMeToBookingStatusPage}
        </SuccessContinue>
      </RequestSuccessContainer>
    </Modal>
  );
};

export default RequestSuccessModal;

const RequestSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 2rem;
  width: 45vw;
  height: 70vh;
  max-height: 34.375rem;
  max-width: 47.75rem;
  @media only screen and (max-width: 800px) {
    width: 75vw;
    height: fit-content;
  }
`;
const HeaderSubheader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
`;
const SuccessHeader = styled.div`
  font-weight: 700;
  font-size: 2.25rem;
  color: ${Colors.brandOne};
`;
const SuccessSubheader = styled.div`
  font-weight: 400;
  font-size: 1.125rem;
  color: ${Colors.mineShaft};
  text-align: center;
  @media only screen and (max-width: 800px) {
    font-size: 0.875rem;
  }
`;
const SuccessContinue = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  color: ${Colors.pomegranate};
  text-align: center;
  cursor: pointer;
`;
const SuccessImg = styled.img`
  height: auto;
  max-width: 100%;
`;
